import { render } from "./AskDialog.vue?vue&type=template&id=f6961a28&ts=true"
import script from "./AskDialog.vue?vue&type=script&lang=ts"
export * from "./AskDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__